import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { OfferHelper } from '@features/offer/helpers';
import { OfferSettingService } from '@features/offer/services/offer-setting.service';
import { TranslateModule } from '@ngx-translate/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-offer-listing-item',
  templateUrl: './offer-listing-item.component.html',
  styleUrls: ['./offer-listing-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconModule, RouterModule, TranslateModule],
})
export class OfferListingItemComponent implements OnInit {
  @HostBinding('class.rd-offer-listing-item') componentClass = true;

  private offerHelper = inject(OfferHelper);
  private offerSettingService = inject(OfferSettingService);
  private urlUtilsService = inject(UrlUtilsService);

  @Input() url = '';
  @Input() cover = '';
  @Input() brand = '';
  @Input() title = '';
  @Input() logo = '';
  @Input() categoryIcon = '';
  @Input() loading = false;

  renderCategoryIcon: boolean;

  fallbackCoverImage = this.urlUtilsService.imageUrl(
    '/images/OH_OfferImage.jpg',
  );

  ngOnInit(): void {
    this.renderCategoryIcon = this.offerSettingService.getRenderCategoryIcon();
  }

  get coverImage() {
    return `${this.cover || this.fallbackCoverImage}?width=630`;
  }

  getComponentRenderState(): ComponentRenderState {
    if (this.loading) {
      return 'loading';
    } else {
      return 'content';
    }
  }

  imageRatioClass(): string {
    return this.offerHelper.imageRatioClass();
  }
}
